export default {
      id: "mfa-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#mfa",
      toString: function () {
        return this.url;
      }
    }